import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp/data-table-v2';
import { formatMoney } from '@/lib/formatUtils';

export const getTableColumns = (handleCellClick?: (row: MuaHangRecord) => void): DataTableColumn[] => [
  {
    field: 'tk',
    headerName: 'Tài khoản',
    width: 100,
    renderCell: params =>
      handleCellClick && params.row.stt !== 0 ? (
        <button
          onClick={e => {
            e.stopPropagation();
            handleCellClick(params.row);
          }}
          className='hover:text-blue-500 hover:underline'
        >
          {params.row.tk}
        </button>
      ) : (
        <span>{params.row.tk}</span>
      )
  },
  {
    field: 'ma_kh',
    headerName: 'Mã nhà cung cấp',
    width: 150,
    cellClassName: params => (params.row.stt === 0 ? 'font-bold' : ''),
    renderCell: params =>
      handleCellClick && params.row.stt !== 0 ? (
        <button
          onClick={e => {
            e.stopPropagation();
            handleCellClick(params.row);
          }}
          className='hover:text-blue-500 hover:underline'
        >
          {params.row.ma_kh}
        </button>
      ) : (
        <span>{params.row.ma_kh}</span>
      )
  },
  {
    field: 'ten_kh',
    headerName: 'Tên nhà cung cấp',
    width: 250,
    cellClassName: params => (params.row.stt === 0 ? 'font-bold' : '')
  },
  {
    field: 'no_dk',
    headerName: 'Dư nợ đầu',
    width: 140,
    type: 'number',
    align: 'right',
    renderCell: (params: DataTableRenderCellParams) => formatMoney((params.value as string | number) ?? 0),
    cellClassName: params => (params.row.stt === 0 ? 'font-bold' : '')
  },
  {
    field: 'co_dk',
    headerName: 'Dư có đầu',
    width: 140,
    type: 'number',
    align: 'right',
    renderCell: (params: DataTableRenderCellParams) => formatMoney((params.value as string | number) ?? 0),
    cellClassName: params => (params.row.stt === 0 ? 'font-bold' : '')
  },
  {
    field: 'ps_no',
    headerName: 'Ps nợ',
    width: 140,
    type: 'number',
    align: 'right',
    renderCell: (params: DataTableRenderCellParams) => formatMoney((params.value as string | number) ?? 0),
    cellClassName: params => (params.row.stt === 0 ? 'font-bold' : '')
  },
  {
    field: 'ps_co',
    headerName: 'Ps có',
    width: 140,
    type: 'number',
    align: 'right',
    renderCell: (params: DataTableRenderCellParams) => formatMoney((params.value as string | number) ?? 0),
    cellClassName: params => (params.row.stt === 0 ? 'font-bold' : '')
  },
  {
    field: 'no_ck',
    headerName: 'Dư nợ cuối',
    width: 140,
    type: 'number',
    align: 'right',
    renderCell: (params: DataTableRenderCellParams) => formatMoney((params.value as string | number) ?? 0),
    cellClassName: params => (params.row.stt === 0 ? 'font-bold' : '')
  },
  {
    field: 'co_ck',
    headerName: 'Dư có cuối',
    width: 140,
    type: 'number',
    align: 'right',
    renderCell: (params: DataTableRenderCellParams) => formatMoney((params.value as string | number) ?? 0),
    cellClassName: params => (params.row.stt === 0 ? 'font-bold' : '')
  }
];
